<template>
    <div class="max-w-5xl mx-auto pb-5 text-center">
        <img src="~/assets/images/icons/icona_regali.png" alt="regalo" class="py-5 mx-auto">
        <h2 class="text-2xl text-secondary">Un Regalo Solidale
            vale doppio!</h2>
        <section class="p-3 prose">
            <article class="py-5">
                <h3 class="text-xl text-secondary pb-5">Si avvicinano le festività e sorge la classica domanda: cosa
                    regalare per Natale?</h3>
                <p class="font-thin">
                    Calzini antiscivolo, tisane rilassanti, tazze personalizzate, guanti caldissimi. Gira e rigira i
                    pensierini di Natale sono sempre simili. Ma esiste un’alternativa: pensare a quale causa supportare
                    attraverso il tuo regalo.Un regalo solidale è un dono offerto da un’organizzazione non profit: ha
                    senso in sé ma ne ha molto di più per quello che può rappresentare.<br /><br />
                    Ecco 3 step per trovare il regalo solidale perfetto per te:
                </p>
            </article>
            <article class="py-5">
                <h3 class="text-xl text-secondary pb-5">1. Scegli il prodotto più adatto</h3>
                <p>
                    Qualcosa da mangiare o da indossare? Un biglietto d'auguri originale o un gadget fatto a mano? La
                    nuova agenda o l'accessorio per distinguersi? Pensa al tuo destinatario e scegli l'oggetto che
                    utilizzerebbe di più.<br /><br />
                    Se su un altro e-commerce sceglieresti per prezzo, negli shop solidali sappi che ogni Euro avrà
                    anche un altro significato: potrai effettuare una piccolissima donazione in cambio di un biglietto
                    d'auguri o regalare più di quanto avresti immaginato, cogliendo l'occasione per lasciare il tuo
                    segno nella vita di qualcuno.<br /><br />
                    Di una cosa potrai star certo: il tuo regalo non sarà dimenticato in nessun cassetto
                    Scegli il prodotto che fa per te.
                </p>
                <h3 class="text-xl text-secondary pb-5">2. Scegli la causa che accomuna te e il destinatario</h3>
                <p>
                    Che si tratti di bambini, ambiente, animali, persone anziane, ricerca medica... ognuno di noi ha un
                    tema o una causa che gli sta più a cuore: trovala e avrai aggiunto al tuo regalo un valore
                    nuovo. Farai capire al destinatario del tuo regalo che lo conosci a fondo, che avete qualcosa in
                    comune.<br /><br />
                    Un regalo dettato dalla tradizione? Forse sì, ma soprattutto un gesto che guarda al futuro. Un
                    momento per riflettere su un problema condiviso e affrontarlo con fiducia. Un'occasione per
                    rafforzare la relazione.<br /><br />

                    <NuxtLink to="/" class="underline">Scegli la causa che vuoi supportare.</NuxtLink>
                </p>
                <h3 class="text-xl text-secondary pb-5">3. Scegli l'ente che ritieni più giusto per te</h3>
                <p>
                    Italia non profit si propone di accogliere gratuitamente tutte le proposte degli enti che accettino
                    di sottoporsi alla verifica della loro trasparenza e accessibilità. Vogliamo dare la medesima
                    visibilità a tutti perché ciascuno possa scegliere l'ente che più lo rappresenta. Ecco 4 aspetti che
                    vi consigliamo di tenere in considerazione per scegliere l'ente da sostenere:<br /><br />
                </p>
                <ul class="list-disc list-inside">
                    <li><span class="font-bold">I progetti e le azioni:</span> l’organizzazione svolge attività per te
                        importanti? Il modello di
                        intervento e l'impatto delle attività ti colpiscono? Nella scelta di un ente da sostenere
                        comprendere se la mission, i progetti realizzati e i valori perseguiti sono coerenti con ciò in
                        cui si crede è il primo passo da fare.</li>
                    <li><span class="font-bold">Apertura e comunicazione:</span> l’organizzazione è raggiungibile?
                        Mostra i
                        risultati ottenuti? La
                        facilità con la quale è possibile mettersi in contatto con l’ente, la capacità di tenere
                        aggiornati i sostenitori e la chiarezza con la quale vengono presentate le attività,
                        facilitano
                        l’esperienza del donatore che deve scegliere.</li>
                    <li><span class="font-bold">Gestione dei fondi e coerenza:</span> con i fondi raccolti quali
                        risultati sono stati raggiunti
                        dall’organizzazione? Avere evidenza degli effetti positivi dell’attività dell’ente e essere
                        messi in condizione di valutarne la coerenza tra obiettivi prefissati, entrate realizzate e
                        risultati ottenuti, permette al donatore di avere una visione più chiara dello sviluppo
                        dell’ente.</li>
                    <li><span class="font-bold">Personale e organizzazione:</span> le risorse umane che operano
                        all’interno dell’ente sono chiare?
                        L’organizzazione interna è comprensibile? Poter comprendere la professionalità del personale,
                        volontario e dipendente, coinvolto nei progetti e nelle attività dell’ente è sempre più un
                        elemento da considerare per una scelta più consapevole.</li>
                </ul>
            </article>
            <article class="py-5">
                <h3 class="text-xl text-secondary pb-5">Ce n'è per tutti i gusti</h3>
                <p class="">
                    Il Natale solidale non significa bancarelle improvvisate. I prodotti offerti seguono le scelte di
                    acquisto del momento e trasmettono un significato: spesso sono fabbricati dai beneficiari dei
                    progetti, oppure rappresentano l’azione di un ente. Dai prodotti più green fino ai “classiconi”
                    natalizi, il non profit offre un'ampia scelta. Senza contare le possibilità di donazione che sono
                    sempre aperte.
                    <NuxtLink to="/" class="underline">Visita la pagina.</NuxtLink>
                </p>
            </article>
            <article class="py-5 text-right">
                <h3 class="text-xl text-secondary pb-5">...e se l'idea di regalare oggetti ti fa sentire un accumulatore
                    seriale, ricordati che puoi sempre donare per un progetto.</h3>
                <p class="">
                    La solidarietà non si ferma ai regali di Natale: scopri <a
                        href="https://italianonprofit.it/enti/cosa-e-possibile-fare-svolgere-attivita-di-volontariato-occasionale/"
                        target="_blank" class="underline">dove fare volontariato</a>, quale
                    organizzazione <a href="https://italianonprofit.it/enti/5x1000-5x1000/" target="_blank"
                        class="underline">sostenere</a>, e tutta la bellezza del <a href="https://italianonprofit.it/"
                        target="_blank" class="underline">Terzo Settore italiano</a>.

                </p>
            </article>

        </section>

        <UiDiscoverMore />
    </div>
</template>

<script setup lang="ts">
// Cambia style di navbar per questa pagina
const navbarType = inject('navbarType')
navbarType.value = 'light';
</script>

<style lang="scss" scoped>
h2,h3{
  @apply py-4;
  font-weight: 600;
}
p,ul{
  @apply text-white;
  font-weight: 100;
}
</style>